import React, {Component} from "react"
import { withRouteData, Link, Head } from 'react-static'
import './Job.scss'
import Footer from "./Footer"
import Header from "./Header"

export default withRouteData(({ job }) => (
  <div className="jobPage">
    <Head>
      <title>Careers - World Singles Networks | We Make Love</title>
      <link rel="shortcut icon" type="image/x-icon" href="/favicon/favicon.ico"/>
    </Head>
    <Header />

    <section className="job">
      <div className="middleContainer">
        <div className="contentContainer reachtext">
            
          <Link to="/careers/">{'<'} Back</Link>
          <br />
          <br />

          <div itemscope="" itemtype="https://schema.org/JobPosting">
            <meta itemprop="specialCommitments" content={job.specialCommitments} />
            <meta itemprop="validThrough" content={job.validThrough} />
            <meta itemprop="datePosted" content={job.datePosted} />
            <meta itemprop="occupationalCategory" content={job.occupationalCategory} />
            <meta itemprop="industry" content={job.industry} />
            <div itemprop="identifier" itemscope="" itemtype="https://schema.org/PropertyValue">
              <meta itemprop="name" content={job.identifier.name} />
              <meta itemprop="value" content={job.identifier.value} />
            </div>
            <div itemprop="baseSalary" itemscope="" itemtype="https://schema.org/MonetaryAmount">
              <meta itemprop="currency" content={job.baseSalary.currency} />
              <span itemprop="value" itemscope="" itemtype="https://schema.org/QuantitativeValue">
                <meta itemprop="minValue" content={job.baseSalary.value.minValue} />
                <meta itemprop="maxValue" content={job.baseSalary.value.maxValue} />
                <meta itemprop="unitText" content={job.baseSalary.value.unitText} />
              </span>
            </div>
            <span itemprop="hiringOrganization" itemscope="" itemtype="https://schema.org/Organization">
              <meta itemprop="name" content={job.hiringOrganization.name} />
              <meta itemprop="sameAs" content={job.hiringOrganization.sameAs} />
              <meta itemprop="logo" content={job.hiringOrganization.logo} />
            </span>
            
            <h1 itemprop="title">{job.title}</h1>
            <span>
              <p><strong>Location: </strong>
                <span itemprop="applicantLocationRequirements" itemscope="" itemtype="https://schema.org/Country">
                  <span itemprop="name">{job.applicantLocationRequirements.name}</span> {job.jobLocationType === "TELECOMMUTE" ? "(Remote)" : ""}
                </span>
              </p>
              <meta itemprop="jobLocationType" content={job.jobLocationType} />
            </span>
            <span itemprop="employmentType">{job.employmentType} position</span>
            <meta itemprop="workHours" content={job.workHours}/>
            <br />
            <br />

            <div itemprop="description">

              <p dangerouslySetInnerHTML={{ __html: job.description }}></p>
              <br />

              <div style={job.sections.responsibilities === false ? {display: 'none'} : {}}>
                <p><strong>Essential Duties and Responsibilities:</strong></p>
                <ul itemprop="responsibilities">
                  {job.responsibilities.map(responsibilitie => <li>{responsibilitie}</li>)}
                </ul>
                <br />
              </div>

              <div style={job.sections.skills === false ? {display: 'none'} : {}}>
                <p><strong>Essential Skills and Experience:</strong></p>
                <ul itemprop="skills">
                  {job.skills.map(skill => <li dangerouslySetInnerHTML={{__html: skill}}></li>)}
                </ul>
                <br />
                <div dangerouslySetInnerHTML={{__html: job.skillsFreeText}}></div>
              </div>
              <br />

              <div style={job.sections.educationRequirements === false ? {display: 'none'} : {}}>
                <p><strong>Educational requirements:</strong></p>
                <ul itemprop="educationRequirements" itemscope="" itemtype="https://schema.org/EducationalOccupationalCredential">
                  {job.educationRequirements.map(educationRequirement => (
                    <li>
                      {educationRequirement.description}
                      <meta itemprop="credentialCategory" content={educationRequirement.credentialCategory} />
                    </li>
                    ))}
                </ul>
                <br />
              </div>

              <div style={job.sections.experienceRequirements === false ? {display: 'none'} : {}}>
                <p><strong>Experience requirements:</strong></p>
                <ul itemprop="experienceRequirements" itemscope="" itemtype="https://schema.org/OccupationalExperienceRequirements">
                  {job.experienceRequirements.map(experienceRequirement => (
                    <li>
                      {experienceRequirement.description}
                      <meta itemprop="monthsOfExperience" content={experienceRequirement.monthsOfExperience} />
                    </li>
                  ))}
                </ul>
                <br />
              </div>

              <div style={job.sections.qualifications === false ? {display: 'none'} : {}}>
                <p><strong>Qualifications:</strong></p>
                <ul itemprop="qualifications">
                  {job.qualifications.map(qualification => <li>{qualification}</li>)}
                </ul>
                <br />
              </div>

              <div style={job.sections.jobBenefits === false ? {display: 'none'} : {}}>
                <p><strong>Benefits:</strong></p>
                <ul itemprop="jobBenefits">
                {job.jobBenefits.map(jobBenefit => <li>{jobBenefit}</li>)}
                </ul>
              </div>
              <br />

            </div>

            <p><strong dangerouslySetInnerHTML={{ __html: job.contactLine }}></strong></p>

            <p>Date Posted: <span itemprop="datePosted">{job.datePosted}</span></p>
          
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
))



// WEBPACK FOOTER //
// /usr/src/app/src/containers/Job.js